import React from "react";
import HeaderSecondary from "components/HeaderSecondary";
import imgMaintenance from "assets/images/maintenance-page/maintenance.jpg";
import PropTypes from "prop-types";
import "./style.scss";

const Maintenance = () => {
    return (
        <div>
            <HeaderSecondary />
            <div className="container">
                <div className="row">
                    <div className="col-sm-6 t  cat">
                        <p>
                            <img src={imgMaintenance} />
                        </p>
                    </div>

                    <div className="col-sm-6 ">
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <strong>
                            <p className="p2">
                                 <p />
                                <p className="p2"></p>¡LAMENTAMOS LAS MOLESTIAS!
                            </p>
                        </strong>
                        <br />
                        <p>Este espacio se encuentra en manteminiento</p>

                        <p>Pronto estara disponible nuevamente</p>
                        <div />
                    </div>
                </div>
            </div>
        </div>
    );
};
Maintenance.propTypes = {
    location: PropTypes.object,
};

export default Maintenance;
